module.exports = "/images/Booking_Steps_Banner_Mobile.jpg?bd66346cdc0dccc34dcc0df910e73235";